import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  ButtonGroup,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import MaterialSelect from "../../../components/MasterSelect";
import { AllRoleDetailsQuery } from "../../../lib/graphQL/graphQuery";
import BASEURL from "../../Utils/Baseurl";
import request, { gql } from "graphql-request";
import { AddEmployeeMutation } from "../../../lib/graphQL/graphMutation";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteEmployeeService,
  updateEmployeeService,
} from "../../../lib/appUtliz/EmployeeService";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";

const getUserDetail = gql`
  query getUserDetail($id: String!) {
    getUserDetail(id: $id) {
      id
      username
      email
      role
      contactno
      lastUpdate
    }
  }
`;
export default function AddEmployees() {
  const { currentUser } = useAuth();
  const params = useLocation();
  const id = params.search.slice(1);
  const navigate = useNavigate();
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const [roleData, setRoleData] = useState([]);

  const { errorStatus, setErrorStatus } = useError();
  const [pendingLoading, setPendingLoading] = useState(false);
  const [selectedData, setselectedData] = useState([]);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [employeeData, setEmployeeData] = useState({
    // Employee Details
    userName: "",
    emailId: "",
    role: "",
    contactNo: "",

    // Employee Status
    userNameStatus: "unchecked",
    emailIdStatus: "unchecked",
    roleStatus: "unchecked",
    contactNoStatus: "unchecked",
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  //UseEffect for Page Toggle
  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  //UseEffect to Fetch Role
  useEffect(() => {
    fetchRoleData();
  }, []);

  //UseEffect to fetch by ID
  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  //Fetch By ID
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getUserDetail, {
        id: id,
      });
      const v = res.getUserDetail;
      setselectedData(v);
      setEmployeeData({
        userName: v.username,
        emailId: v.email,
        role: {
          value: v.role,
          label: v.role,
        },
        contactNo: v.contactno,

        // Employee Status
        userNameStatus: "success",
        emailIdStatus: "success",
        roleStatus: "success",
        contactNoStatus: "success",
      });
    } catch (err) {
      console.error("Error Fetching Data",err);
    }
  };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setEmployeeData({
      userName: selectedData.username,
      emailId: selectedData.email,
      role: {
        value: selectedData.role,
        label: selectedData.role,
      },
      contactNo: selectedData.contactno,

      // Employee Status
      userNameStatus: "success",
      emailIdStatus: "success",
      roleStatus: "success",
      contactNoStatus: "success",
    });
  };

  //Handle Change
  const handleEmployeeDataChange = (event, selectEvent) => {
    let employeeState = { ...employeeData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "role":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              employeeState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              employeeState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      employeeState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "userName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "emailId":
          {
            const gmailRegex =
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (gmailRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactNo":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      employeeState[event.target.name] = event.target.value;
    }

    setEmployeeData(employeeState);
  };

  //Fetch Role
  const fetchRoleData = () => {
    request(BASEURL, AllRoleDetailsQuery, { id: currentUser?.id })
      .then((res) => {
        setRoleData(res.allRoleDetail);
      })
      .catch((err) => {
        setRoleData([]);
      });
  };

  //Create Mutation
  const handleAddEmployeeData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        try {
          const response = await request(BASEURL, AddEmployeeMutation, {
            masterId: currentUser?.id,
            username: employeeData.userName,
            email: employeeData.emailId,
            role: employeeData.role?.label,
            contactno: employeeData.contactNo,
          });
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });

          setSuccessStatus(true);
          setSucessTitle("Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/employee");
          }, 1000);
        } catch (error) {
          console.error(error.message);
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });

          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        } finally {
          setCirleLoading(false);
        }
      },

      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Update Mutation
  const handleEditEmployeesData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          // id: employeeData.id,
          username: employeeData.userName,
          email: employeeData.emailId,
          role: employeeData.role?.label,
          contactno: employeeData.contactNo,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const updateStatus = await updateEmployeeService(id, values);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/employee");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Function
  const handledeleteEmployeesData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await deleteEmployeeService(id);
        setPendingLoading(false);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/employee");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

    //Submit Validation
    const checkAllFields = () => {
      let allowSubmit = false;
      if (
        employeeData.userNameStatus === "success" &&
        employeeData.emailIdStatus === "success" &&
        employeeData.roleStatus === "success" &&
        employeeData.contactNoStatus === "success"
      ) {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
      return allowSubmit;
    };

  //Cancel Function
  const handleCancelEmployeeData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/employee");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Employee Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={handledeleteEmployeesData}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium" fontFamily="Aptos">
                      Add Employee Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
         <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
             <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058', }} />
             <MaterialTypography
             sx={{color:'#460058',fontFamily:'Aptos',fontSize: '0.938rem', }}
               component="label"
               variant="body2"
             >
               Employee Information
             </MaterialTypography>
           </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    User Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="userName"
                  size="small"
                  placeholder="Enter Employee Name"
                  value={employeeData.userName}
                  onChange={handleEmployeeDataChange}
                  error={employeeData.userNameStatus === "error" ? true : false}
                  success={
                    employeeData.userNameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {employeeData.userNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      User Name should be maximum 30 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Email ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="emailId"
                  size="small"
                  placeholder="eg. Admin@gmail.com"
                  value={employeeData.emailId}
                  onChange={handleEmployeeDataChange}
                  error={employeeData.emailIdStatus === "error" ? true : false}
                  success={
                    employeeData.emailIdStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {employeeData.emailIdStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter Valid Email Address</FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Role <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="role"
                  size="small"
                  value={employeeData.role}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleEmployeeDataChange} //selectedValue, event
                  options={roleData?.map((value) => {
                    return {
                      value: value.role,
                      label: value.role,
                    };
                  })}
                  error={employeeData.roleStatus === "error" ? true : false}
                  success={employeeData.roleStatus === "success" ? true : false}
                  isDisabled={togglePage?.view === true ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Contact Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="contactNo"
                  placeholder="98401*****"
                  size="small"
                  value={employeeData.contactNo}
                  onChange={handleEmployeeDataChange}
                  error={
                    employeeData.contactNoStatus === "error" ? true : false
                  }
                  success={
                    employeeData.contactNoStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {employeeData.contactNoStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Valid Contact Number
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            mt={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleEditEmployeesData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleCancelEmployeeData}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleAddEmployeeData}
                >
                  Submit
                </MaterialButton>
                
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
